import { createArrayWithBracesParser, encodedStringParser, stringParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
function loginWindowButtonParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return {
        label: inboundParts[0],
        actionType: inboundParts[1]
    };
}
export const SHOW_LOGIN_WINDOW_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'page', parser: stringParser },
        { name: 'message', parser: encodedStringParser },
        { name: 'buttons', parser: createArrayWithBracesParser(loginWindowButtonParser) }
    ]
};
